// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2DoAa","col":"styles_col__fTr7z","fulfillmentStatus":"styles_fulfillmentStatus__22vh4","emailCol":"styles_emailCol__38qR9"};